import {
  AudioTags,
  tTaskAudioManagerItems
} from 'students/views/shared/bundles/audio/models';

import mp3BgMusic from './bg_music.mp3';

/** Namespaced per game: every game has its own `bg_music.mp3`. */
export const WordWaterfallAudioIds = {
  background: 'game:wordwaterfall:background'
} as const;

/** Background music only — the effects come from `useGameAudioPlayer`. */
export const audioItems: tTaskAudioManagerItems = [
  {
    id: WordWaterfallAudioIds.background,
    tags: [AudioTags.MusicPlayback],
    src: mp3BgMusic,
    html5: false,
    autoplay: true,
    loop: true,
    volume: 0.1
  }
];
